import { createContext, useContext, useState, type PropsWithChildren } from 'react';
import { cn } from '../../utils/cn';

type FaqProps = PropsWithChildren & {
  className?: string;
};

type FaqContext = {
  openItemId?: string;
  setOpenItemId: ( id: string ) => void;
}

const FaqContext = createContext<FaqContext>( {
  openItemId: undefined,
  setOpenItemId: () => {
    throw new Error( 'FAQ Context provider is missing' )
  }
} )

export const useFaq = () => useContext( FaqContext );

export const Faq = ( { children, className }: FaqProps ) => {
  const [ openItemId, setOpenItemId ] = useState<string | undefined>();

  return (
    <FaqContext.Provider value={ {
      openItemId,
      setOpenItemId( id: string ) {
        setOpenItemId( id )
      }
    } }>
      <div className={ cn( 'flex flex-col gap-5', className ) }>
        { children }
      </div>
    </FaqContext.Provider>
  )
}
Faq.displayName = 'Faq';
